// import { X, Calendar } from "lucide-react";

// export default function CreateEventDrawer({ open, onClose, date }) {
//     if (!open) return null;

//     return (
//         <div className="fixed inset-0 z-50 flex">
//             {/* BACKDROP */}
//             <div
//                 className="absolute inset-0 bg-black/40"
//                 onClick={onClose}
//             />
//             {console.log('Su thai che', onClose)}
//             {/* PANEL */}
//             <div className="relative mx-auto w-[700px] h-full bg-white rounded-l-3xl shadow-2xl flex overflow-hidden items-center">

//                 {/* LEFT FORM */}
//                 <div className="w-1/2 p-6 overflow-y-auto">
//                     <div className="flex items-center justify-between mb-6">
//                         <h3 className="text-xl font-semibold">Create</h3>
//                         <button onClick={onClose}>
//                             <X className="w-5 h-5 text-gray-500" />
//                         </button>
//                     </div>

//                     {/* TABS */}
//                     <div className="flex gap-4 mb-6 text-sm">
//                         <span className="text-blue-600 font-medium">Event</span>
//                         <span className="text-gray-400">Reminder</span>
//                     </div>

//                     {/* FORM */}
//                     <input
//                         className="w-full text-lg border-b pb-2 mb-4 outline-none"
//                         placeholder="Enter Title"
//                     />

//                     <input
//                         className="w-full text-sm text-gray-500 border-b pb-2 mb-6 outline-none"
//                         placeholder="Enter Subtitle"
//                     />

//                     <div className="flex justify-between items-center mb-4">
//                         <span className="text-sm">All Day Event</span>
//                         <input type="checkbox" />
//                     </div>

//                     <div className="space-y-3">
//                         <div className="flex gap-3">
//                             <input className="flex-1 border rounded-xl px-3 py-2" value={`Dec ${date}`} readOnly />
//                             <input className="flex-1 border rounded-xl px-3 py-2" value="08:30 PM" readOnly />
//                         </div>
//                     </div>

//                     <div className="mt-6">
//                         <p className="text-sm mb-2">Invitees</p>
//                         <span className="inline-block bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">
//                             Alisha (You)
//                         </span>
//                     </div>
//                 </div>

//                 {/* RIGHT DATE VIEW */}
//                 <div className="w-1/2 bg-gray-50 flex flex-col items-center justify-center">
//                     <div className="text-7xl font-semibold">{date}</div>
//                     <div className="text-blue-600 text-lg mt-2">Tuesday</div>
//                     <div className="text-gray-500">December</div>

//                     <button className="mt-8 px-6 py-3 border rounded-xl flex items-center gap-2">
//                         <Calendar className="w-4 h-4" />
//                         Today’s Date
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// }
// import React, { useState } from "react"
// import { X, Calendar, ChevronDown } from "lucide-react";

// export default function CreateEventDrawer({ open, onClose, date }) {
//     const [title, setTitle] = useState("");
//     if (!open) return null;

//     return (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-6">
//             {/* BACKDROP */}
//             <div
//                 className="absolute inset-0 bg-black/50 backdrop-blur-sm"
//                 onClick={onClose}
//             />

//             {/* MAIN PANEL */}
//             <div className="relative bg-white rounded-2xl w-full max-w-4xl shadow-2xl max-h-[90vh] overflow-hidden flex">

//                 {/* LEFT SIDE - FORM */}
//                 <div className="flex-1 overflow-y-auto p-6 space-y-6">
//                     {/* Header */}
//                     <div className="border-b border-gray-200 pb-6 sticky top-0 bg-white z-10">
//                         <div className="flex items-center justify-between mb-6">
//                             <div className="flex items-center gap-2 text-gray-600">
//                                 {/* Breadcrumb chevrons (decorative) */}
//                                 <ChevronDown className="w-5 h-5 rotate-180" />
//                                 <ChevronDown className="w-5 h-5 rotate-180" />
//                             </div>
//                             <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
//                                 <X className="w-6 h-6" />
//                             </button>
//                         </div>

//                         <div className="flex items-center gap-4 mb-6">
//                             <h3 className="text-xl text-gray-900">Create:</h3>
//                             <button className="text-xl text-blue-600 font-medium">Event</button>
//                             <span className="text-gray-300">|</span>
//                             <button className="text-xl text-gray-400 hover:text-gray-600">Reminder</button>
//                         </div>

//                         {/* Event Type Preview Card */}
//                         <div className="flex items-start justify-between">
//                             <div className="flex items-center gap-3">
//                                 <div className="rounded-xl p-2 bg-blue-50">
//                                     <Calendar className="w-6 h-6 text-blue-600" />
//                                 </div>
//                                 <div>
//                                     <p className="text-gray-900 font-medium">Event</p>
//                                     <p className="text-sm text-gray-500">Set your team's next milestone or meeting in seconds.</p>
//                                 </div>
//                             </div>
//                             {/* <button disabled={!title.trim()}
//                                 className={`px-6 py-2 rounded-lg transition-colors
//                                         ${title.trim()
//                                         ? "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
//                                         : "bg-gray-100 border border-gray-200 text-gray-400 cursor-not-allowed"
//                                     }`}>
//                                 Create
//                             </button> */}
//                             <button
//                                 onClick={() => {
//                                     if (!title.trim()) return;
//                                     // Create logic here
//                                 }}
//                                 className={`px-6 py-2 rounded-lg transition-colors
//                                     ${title.trim()
//                                         ? "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 cursor-pointer"
//                                         : "bg-gray-100 border border-gray-200 text-gray-400 cursor-default pointer-events-none"
//                                     }`}
//                             >
//                                 Create
//                             </button>
//                         </div>
//                     </div>

//                     {/* Form Fields */}
//                     <div>
//                         <input
//                             type="text"
//                             placeholder="Enter Title"
//                             value={title}
//                             onChange={(e) => setTitle(e.target.value)}
//                             className="w-full text-2xl font-medium text-gray-900 placeholder-gray-400 border-0 border-b border-gray-200 focus:outline-none focus:border-blue-500 pb-2"
//                         // defaultValue="zcdsd"
//                         />
//                     </div>

//                     <div>
//                         <input
//                             type="text"
//                             placeholder="Enter Subtitle"
//                             className="w-full text-gray-600 placeholder-gray-400 border-0 focus:outline-none"
//                         />
//                     </div>

//                     {/* All Day Toggle */}
//                     <div className="flex items-center justify-between bg-gray-50 rounded-xl p-4">
//                         <span className="text-gray-700">All Day Event</span>
//                         <label className="relative inline-flex items-center cursor-pointer">
//                             <input type="checkbox" className="sr-only peer" />
//                             <div className="w-12 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:bg-blue-600 transition-colors">
//                                 <div className="w-4 h-4 bg-white rounded-full shadow-md transform translate-x-1 peer-checked:translate-x-6 transition-transform"></div>
//                             </div>
//                         </label>
//                     </div>

//                     {/* Start & End Date/Time */}
//                     <div className="grid grid-cols-2 gap-4">
//                         <div>
//                             <label className="text-sm text-gray-600 block mb-2">Starts</label>
//                             <input
//                                 type="text"
//                                 readOnly
//                                 value={`Dec ${date}`}
//                                 className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2 text-gray-700"
//                             />
//                         </div>
//                         <div>
//                             <label className="text-sm text-gray-600 block mb-2">&nbsp;</label>
//                             <input
//                                 type="text"
//                                 value="08:30 PM"
//                                 className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2 text-orange-600"
//                             />
//                         </div>
//                     </div>

//                     <div className="grid grid-cols-2 gap-4">
//                         <div>
//                             <label className="text-sm text-gray-600 block mb-2">Ends</label>
//                             <input
//                                 type="text"
//                                 readOnly
//                                 value={`Dec ${date}`}
//                                 className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2 text-gray-700"
//                             />
//                         </div>
//                         <div>
//                             <label className="text-sm text-gray-600 block mb-2">&nbsp;</label>
//                             <input
//                                 type="text"
//                                 value="08:30 PM"
//                                 className="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2 text-orange-600"
//                             />
//                         </div>
//                     </div>

//                     {/* Invitees */}
//                     <div>
//                         <label className="text-sm text-gray-700 block mb-2">Invitees</label>
//                         <div className="flex items-center gap-2">
//                             <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">
//                                 Alisha (You)
//                             </span>
//                         </div>
//                     </div>

//                     {/* Add Client */}
//                     <div>
//                         <label className="text-sm text-gray-700 block mb-2">Add Client</label>
//                         <input
//                             type="text"
//                             placeholder="Select client"
//                             className="w-full bg-white border border-gray-200 rounded-lg px-4 py-2 text-gray-600 placeholder-gray-400 focus:outline-none focus:border-blue-500"
//                         />
//                     </div>

//                     {/* Remarks */}
//                     <div>
//                         <label className="text-sm text-gray-700 block mb-2">Remarks</label>
//                         <input
//                             type="text"
//                             placeholder="Remarks Content"
//                             className="w-full bg-white border border-gray-200 rounded-lg px-4 py-2 text-gray-600 placeholder-gray-400 focus:outline-none focus:border-blue-500"
//                         />
//                     </div>

//                     {/* Tags */}
//                     <div>
//                         <label className="text-sm text-gray-700 block mb-2">Tags</label>
//                         <button className="w-full bg-white border border-gray-200 rounded-lg px-4 py-2 text-gray-400 text-left flex items-center justify-between hover:border-blue-500 transition-colors">
//                             Select Tags
//                             <ChevronDown className="w-4 h-4" />
//                         </button>
//                     </div>

//                     {/* URL */}
//                     <div>
//                         <label className="text-sm text-gray-700 block mb-2">URL</label>
//                         <input
//                             type="text"
//                             placeholder="www.simplifyte.com"
//                             className="w-full bg-white border border-gray-200 rounded-lg px-4 py-2 text-gray-600 placeholder-gray-400 focus:outline-none focus:border-blue-500"
//                         />
//                     </div>
//                 </div>

//                 {/* RIGHT SIDE - CALENDAR PREVIEW */}
//                 <div className="w-80 bg-gray-50 border-l border-gray-200 p-6 flex flex-col">
//                     <div className="flex-1 flex items-center justify-center">
//                         <div className="text-center">
//                             <div className="text-8xl font-bold text-gray-900 mb-2">{date}</div>
//                             <div className="text-xl text-blue-600 mb-1">Monday</div>
//                             <div className="text-lg text-gray-600">December</div>
//                         </div>
//                     </div>

//                     <button className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 flex items-center justify-center gap-2 hover:bg-gray-50 transition-colors">
//                         <Calendar className="w-4 h-4 text-blue-600" />
//                         Today's Date
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// }

import React, { useState } from "react";
import { ChevronLeft, X, Calendar, Bell, Cake } from "lucide-react";
export default function CreateEventDrawer({ open, onClose, date, onCreate }) {
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [type, setType] = useState("event"); // 'event' or 'reminder' or 'birthday'
  const [allDay, setAllDay] = useState(false);
  const [time, setTime] = useState("08:30 PM");
  const [tags, setTags] = useState([]);

  if (!open) return null;

  const handleCreate = () => {
    if (!title.trim()) return;

    const newEvent = {
      type: type,
      title: title,
      time: allDay ? "All Day" : time,
      tags: type === "birthday" ? ["Birthday"] : ["Work"],
      action: type === "reminder" ? "Mark Done" : undefined,
      invitees: type === "event" ? "1 invitee" : undefined,
      location: type === "event" ? "Zoom" : undefined,
    };

    onCreate(newEvent);

    // Reset form
    setTitle("");
    setSubtitle("");
    setType("event");
    setAllDay(false);
    setTime("08:30 PM");
    setTags([]);
  };

  return (
    <>
      <div className="hidden md:flex fixed inset-0 z-50 flex items-center justify-center p-6">
        <div
          className="absolute inset-0 bg-black/50 backdrop-blur-sm"
          onClick={onClose}
        />
        {/* relative bg-white rounded-2xl w-full max-w-4xl shadow-2xl max-h-[90vh]
             overflow-hidden flex */}
        <div className=" CreateEventDrawer_popup_Main_Class">
          <div className="flex-1 overflow-y-auto p-6 space-y-6">
            <div className="border-b border-gray-200 pb-6 sticky top-0 bg-white z-10">
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-2 text-gray-600">
                  <ChevronLeft className="w-5 h-5 rotate-180" />
                  <ChevronLeft className="w-5 h-5 rotate-180" />
                </div>
                <button
                  onClick={onClose}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              <div className="flex items-center gap-4 mb-6">
                <h3 className="text-xl text-gray-900">Create:</h3>
                <button
                  onClick={() => setType("event")}
                  className={`text-xl ${type === "event" ? "text-blue-600 font-medium" : "text-gray-400 hover:text-gray-600"}`}
                >
                  Event
                </button>
                <span className="text-gray-300">|</span>
                <button
                  onClick={() => setType("reminder")}
                  className={`text-xl ${type === "reminder" ? "text-blue-600 font-medium" : "text-gray-400 hover:text-gray-600"}`}
                >
                  Reminder
                </button>
                <span className="text-gray-300">|</span>
                <button
                  onClick={() => setType("birthday")}
                  className={`text-xl ${type === "birthday" ? "text-blue-600 font-medium" : "text-gray-400 hover:text-gray-600"}`}
                >
                  Birthday
                </button>
              </div>

              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div
                    className={`rounded-xl p-2 ${
                      type === "event"
                        ? "bg-blue-50"
                        : type === "reminder"
                          ? "bg-purple-50"
                          : "bg-pink-50"
                    }`}
                  >
                    {type === "event" && (
                      <Calendar className="w-6 h-6 text-blue-600" />
                    )}
                    {type === "reminder" && (
                      <Bell className="w-6 h-6 text-purple-600" />
                    )}
                    {type === "birthday" && (
                      <Cake className="w-6 h-6 text-pink-600" />
                    )}
                  </div>
                  <div>
                    <p className="text-gray-900 font-medium">
                      {type === "event" && "Event"}
                      {type === "reminder" && "Reminder"}
                      {type === "birthday" && "Birthday"}
                    </p>
                    <p className="text-sm text-gray-500">
                      {type === "event" &&
                        "Set your team's next milestone or meeting in seconds."}
                      {type === "reminder" &&
                        "Set an important reminder that you won't forget."}
                      {type === "birthday" &&
                        "Add a birthday celebration to remember."}
                    </p>
                  </div>
                </div>
                <button
                  onClick={handleCreate}
                  className={`px-6 py-2 rounded-lg transition-colors
                  ${
                    title.trim()
                      ? "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 cursor-pointer"
                      : "bg-gray-100 border border-gray-200 text-gray-400 cursor-default pointer-events-none"
                  }`}
                >
                  Create
                </button>
              </div>
            </div>

            <div>
              <input
                type="text"
                placeholder="Enter Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="w-full text-2xl font-medium text-gray-900 placeholder-gray-400 border-0 border-b border-gray-200 focus:outline-none focus:border-blue-500 pb-2"
              />
            </div>

            <div>
              <input
                type="text"
                placeholder="Enter Subtitle (Optional)"
                value={subtitle}
                onChange={(e) => setSubtitle(e.target.value)}
                className="w-full text-gray-600 placeholder-gray-400 border-0 focus:outline-none"
              />
            </div>

            {type !== "birthday" && (
              <div className="flex items-center justify-between bg-gray-50 rounded-xl p-4">
                <span className="text-gray-700">All Day Event</span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={allDay}
                    onChange={(e) => setAllDay(e.target.checked)}
                  />
                  <div className="w-12 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:bg-blue-600 transition-colors">
                    <div
                      className={`w-4 h-4 bg-white rounded-full shadow-md transform mt-1 ${allDay ? "translate-x-1 translate-x-6 transition-transform" : "translate-x-1 peer-checked:translate-y-6 transition-transform"}`}
                    ></div>
                  </div>
                </label>
              </div>
            )}

            {!allDay && (
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-sm text-gray-600 block mb-2">
                    Time
                  </label>
                  <input
                    type="text"
                    value={time}
                    onChange={(e) => setTime(e.target.value)}
                    placeholder="08:30 PM"
                    className="w-full bg-white border border-gray-200 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:border-blue-500"
                  />
                </div>
              </div>
            )}

            {type === "event" && (
              <>
                <div>
                  <label className="text-sm text-gray-700 block mb-2">
                    Invitees
                  </label>
                  <div className="flex items-center gap-2">
                    <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">
                      Alisha (You)
                    </span>
                    <span className="text-gray-400 text-sm">+ Add more</span>
                  </div>
                </div>

                <div>
                  <label className="text-sm text-gray-700 block mb-2">
                    Location
                  </label>
                  <input
                    type="text"
                    placeholder="Zoom, Office, etc."
                    className="w-full bg-white border border-gray-200 rounded-lg px-4 py-2 text-gray-600 placeholder-gray-400 focus:outline-none focus:border-blue-500"
                  />
                </div>
              </>
            )}

            <div>
              <label className="text-sm text-gray-700 block mb-2">Tags</label>
              <div className="flex gap-2 flex-wrap">
                {type === "event" &&
                  ["Meeting", "Work", "Personal"].map((tag) => (
                    <button
                      key={tag}
                      onClick={() =>
                        setTags((prev) =>
                          prev.includes(tag)
                            ? prev.filter((t) => t !== tag)
                            : [...prev, tag],
                        )
                      }
                      className={`px-3 py-1 rounded-full text-sm ${
                        tags.includes(tag)
                          ? "bg-blue-100 text-blue-700 border border-blue-200"
                          : "bg-gray-100 text-gray-700 border border-gray-200"
                      }`}
                    >
                      {tag}
                    </button>
                  ))}
                {type === "reminder" &&
                  ["Urgent", "Work", "Personal"].map((tag) => (
                    <button
                      key={tag}
                      onClick={() =>
                        setTags((prev) =>
                          prev.includes(tag)
                            ? prev.filter((t) => t !== tag)
                            : [...prev, tag],
                        )
                      }
                      className={`px-3 py-1 rounded-full text-sm ${
                        tags.includes(tag)
                          ? "bg-purple-100 text-purple-700 border border-purple-200"
                          : "bg-gray-100 text-gray-700 border border-gray-200"
                      }`}
                    >
                      {tag}
                    </button>
                  ))}
                {type === "birthday" &&
                  ["Family", "Friend", "Work"].map((tag) => (
                    <button
                      key={tag}
                      onClick={() =>
                        setTags((prev) =>
                          prev.includes(tag)
                            ? prev.filter((t) => t !== tag)
                            : [...prev, tag],
                        )
                      }
                      className={`px-3 py-1 rounded-full text-sm ${
                        tags.includes(tag)
                          ? "bg-pink-100 text-pink-700 border border-pink-200"
                          : "bg-gray-100 text-gray-700 border border-gray-200"
                      }`}
                    >
                      {tag}
                    </button>
                  ))}
              </div>
            </div>
          </div>

          <div className="w-80 bg-gray-50 border-l border-gray-200 p-6 flex flex-col">
            <div className="flex-1 flex items-center justify-center">
              <div className="text-center">
                <div className="text-8xl font-bold text-gray-900 mb-2">
                  {date}
                </div>
                <div className="text-xl text-blue-600 mb-1">Monday</div>
                <div className="text-lg text-gray-600">December 2025</div>
              </div>
            </div>

            <button className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 flex items-center justify-center gap-2 hover:bg-gray-50 transition-colors">
              <Calendar className="w-4 h-4 text-blue-600" />
              Today's Date
            </button>
          </div>
        </div>
      </div>
      <div className=" md:hidden flex fixed inset-0 z-50 flex items-center justify-center p-4 md:p-6">
        {/* Backdrop */}
        <div
          className="absolute inset-0 bg-black/50 backdrop-blur-sm"
          onClick={onClose}
        />

        {/* Main panel - fully responsive */}
        <div className="relative bg-white rounded-2xl w-full max-w-4xl shadow-2xl max-h-[90vh] overflow-hidden flex flex-col md:flex-row">
          {/* LEFT SIDE - FORM */}
          <div className="flex-1 overflow-y-auto p-4 md:p-6 space-y-4 md:space-y-6">
            {/* Header section (sticky) */}
            <div className="border-b border-gray-200 pb-4 md:pb-6 sticky top-0 bg-white z-10">
              <div className="flex items-center justify-between mb-4 md:mb-6">
                <div className="flex items-center gap-2 text-gray-600">
                  <ChevronLeft className="w-5 h-5 rotate-180" />
                  <ChevronLeft className="w-5 h-5 rotate-180" />
                </div>
                <button
                  onClick={onClose}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="w-5 h-5 md:w-6 md:h-6" />
                </button>
              </div>

              <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-4 md:mb-6">
                <h3 className="text-lg md:text-xl text-gray-900">Create:</h3>
                <button
                  onClick={() => setType("event")}
                  className={`text-lg md:text-xl ${type === "event" ? "text-blue-600 font-medium" : "text-gray-400 hover:text-gray-600"}`}
                >
                  Event
                </button>
                <span className="text-gray-300">|</span>
                <button
                  onClick={() => setType("reminder")}
                  className={`text-lg md:text-xl ${type === "reminder" ? "text-blue-600 font-medium" : "text-gray-400 hover:text-gray-600"}`}
                >
                  Reminder
                </button>
                <span className="text-gray-300">|</span>
                <button
                  onClick={() => setType("birthday")}
                  className={`text-lg md:text-xl ${type === "birthday" ? "text-blue-600 font-medium" : "text-gray-400 hover:text-gray-600"}`}
                >
                  Birthday
                </button>
              </div>

              <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
                <div className="flex items-center gap-3">
                  <div
                    className={`rounded-xl p-2 ${
                      type === "event"
                        ? "bg-blue-50"
                        : type === "reminder"
                          ? "bg-purple-50"
                          : "bg-pink-50"
                    }`}
                  >
                    {type === "event" && (
                      <Calendar className="w-5 h-5 md:w-6 md:h-6 text-blue-600" />
                    )}
                    {type === "reminder" && (
                      <Bell className="w-5 h-5 md:w-6 md:h-6 text-purple-600" />
                    )}
                    {type === "birthday" && (
                      <Cake className="w-5 h-5 md:w-6 md:h-6 text-pink-600" />
                    )}
                  </div>
                  <div>
                    <p className="text-gray-900 font-medium capitalize">
                      {type}
                    </p>
                    <p className="text-xs md:text-sm text-gray-500 max-w-xs">
                      {type === "event" &&
                        "Set your team's next milestone or meeting in seconds."}
                      {type === "reminder" &&
                        "Set an important reminder that you won't forget."}
                      {type === "birthday" &&
                        "Add a birthday celebration to remember."}
                    </p>
                  </div>
                </div>
                <button
                  onClick={handleCreate}
                  className={`px-4 md:px-6 py-2 rounded-lg transition-colors whitespace-nowrap ${
                    title.trim()
                      ? "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 cursor-pointer"
                      : "bg-gray-100 border border-gray-200 text-gray-400 cursor-default pointer-events-none"
                  }`}
                >
                  Create
                </button>
              </div>
            </div>

            {/* Form fields - unchanged except responsive padding */}
            <input
              type="text"
              placeholder="Enter Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full text-xl md:text-2xl font-medium text-gray-900 placeholder-gray-400 border-0 border-b border-gray-200 focus:outline-none focus:border-blue-500 pb-2"
            />

            <input
              type="text"
              placeholder="Enter Subtitle (Optional)"
              value={subtitle}
              onChange={(e) => setSubtitle(e.target.value)}
              className="w-full text-gray-600 placeholder-gray-400 border-0 focus:outline-none"
            />

            {/* ... rest of your form fields remain the same ... */}
            {/* (All Day toggle, Time, Invitees, Location, Tags) */}
            {/* Just make sure they use responsive spacing where needed */}
          </div>

          {/* RIGHT SIDE - CALENDAR PREVIEW (now responsive) */}
          <div className="w-full md:w-80 bg-gray-50 border-t md:border-l md:border-t-0 border-gray-200 p-4 md:p-6 flex flex-col">
            <div className="flex-1 flex items-center justify-center">
              <div className="text-center">
                <div className="text-6xl md:text-8xl font-bold text-gray-900 mb-2">
                  {date}
                </div>
                <div className="text-lg md:text-xl text-blue-600 mb-1">
                  Monday
                </div>
                <div className="text-base md:text-lg text-gray-600">
                  December 2025
                </div>
              </div>
            </div>

            <button className="w-full bg-white border border-gray-300 rounded-lg px-4 py-2 md:py-3 text-gray-700 flex items-center justify-center gap-2 hover:bg-gray-50 transition-colors text-sm md:text-base">
              <Calendar className="w-4 h-4 text-blue-600" />
              Today's Date
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
